// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"94b4f229","453":"0369f315","455":"34118ee8","977":"9e293bd4"}[chunkId] + ".chunk.js";
};